import { ISelect } from './index';
import { IOrdersListItem, IOrdersListItemAPI } from './orders';
import { IMeta } from '../REST';

export enum billingSystemOrderStatuses {
    PENDING = 'pending',
    PAID = 'paid',
    CANCELED = 'canceled',
    OVERDUE = 'overdue',
    DRAFT = 'draft',
}

type BillingOrderProductAPI = {
    description: string;
    units: number;
    unit_price: number;
};

export type BillingOrderProduct = {
    description: string;
    units: number;
    unitPrice: number;
};

export interface IBillingSystemOrdersListAPI {
    orders?: IBillingSystemOrdersListItemAPI[];
    meta?: IMeta;
}

export interface IBillingSystemOrdersListItemAPI extends IOrdersListItemAPI {
    status_overall: string;
    products: BillingOrderProductAPI[];
    discount: {
        description: string;
        amount: string;
        amount_type: string;
    };
}

export interface IBillingSystemOrdersListItem extends IOrdersListItem {
    statusOverall?: billingSystemOrderStatuses;
    products?: BillingOrderProduct[];
    discount?: {
        description: string;
        amount: string;
        amountType: string;
    };
}

export type IBillingSystemCompany = ISelect & {
    currencyAbbreviation: string;
};

export type IBillingSystemCompanySelectItem = IBillingSystemCompany & {
    deletedAt: string;
    invoicedByCompanyId: string;
    paymentTerms: number;
};

export type IBillingSystemCompanyAPI = {
    id: number;
    name: string;
    currency_abbreviation: string;
};
export type IBillingSystemCompanySelectItemAPI = IBillingSystemCompanyAPI & {
    deleted_at: string;
    invoiced_by_company_id: string;
};

export interface IBillingSystemCompanySelectAPI {
    companies?: IBillingSystemCompanySelectItemAPI[];
    meta?: IMeta;
}

export interface IBillingSystemPostInvoiceNumberBody {
    invoice_configuration: {
        company_code: string;
        account_number?: string;
        invoice_footer?: string;
        iban?: string;
        swift?: string;
    };
}
